export default __webpack_public_path__ + "static/media/welcomeModal.4ab5970f.png";